import React from "react";
import { FaChevronLeft } from "react-icons/fa";

export const ProjectDetails = () => {
  return (
    <div className="project-details">
    <a className="back-to-projects" href="/projects">
              <span><FaChevronLeft /></span>
      <p>
      Back to projects
      </p>
</a>
      <h1 className="project-title-info">Terra Brite - Bathrooms</h1>
      <h2  className="work-description">Residential interior work</h2>
      <p className="work-details">New projects, contruction additions and remodeling</p>
    </div>
  );
};
